export default {
  path: '/industry-mana/index',
  name: 'Industry.Search',
  meta: { icon: 'profile', title: '行业管理', bread: true },
  component: () =>
    import(/* webpackChunkName: 'clientMana' */ '@/views/industry-mana/index.vue')
}
